module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH5QQIDyUUQxztGQAAAGRJREFUaN7t1kEKwCAMAMGk//9zei8UekkjOvMBXRRjBAAAAMAnFVEVUX+slRNxjw3kNoFvp9YZmdNx3ZG5QlxnZK4S1xWZK8V1RF67jyRX1CNjTBwy6Ke+att/tgEAAAAATnMDiwYeBgw1aiUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/dot.png
// module id = f6T9
// module chunks = 1